import {ajaxCall_changeRefinements} from './ajaxCall';
import {
    initProdTileCarousel,
    unslickProdTileCarousel,
} from '../productTileComponent/productTileCarousel';
import {closeAllQuickAdd} from '../productTileComponent/productTile';

export {openRefinements};

/**
 * $button = $('.js-plp-refineBar-refinements')
 */
// SELECTOR ELEMENT CLASS USED LIST
const MENUREFINEMENT = '.js-plp-refinements';
const PRODUCTGRID = '.js-plp-productGrid';
const PAGINATION = '.js-plp-pagination';

// VARIANT CLASS ADDED - REMOVED
const BUTTON_OPEN = 'cc-plp-refineBar-button_open';
const MENU_OPEN = 'cc-plp-refinements_open';
const PRODUCTGRID_OPEN = 'cc-plp-productGrid_open';

function openRefinements() {
    const $button = $(this);
    $button.off('click').addClass(BUTTON_OPEN);
    const $menu = $(MENUREFINEMENT);

    addEventRefinements($button, $menu);

    if (Foundation.MediaQuery.atLeast('large')) {
        unslickProdTileCarousel(PRODUCTGRID);

        if (Foundation.MediaQuery.is('large only')) {
            closeAllQuickAdd();
        }

        movePageOnFilterOpen().then(function () {
            $menu.addClass(MENU_OPEN);
            const $productGrid = $(PRODUCTGRID);
            $productGrid
                .addClass(PRODUCTGRID_OPEN)
                .on(
                    'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
                    function () {
                        initProdTileCarousel(PRODUCTGRID);
                        autoCloseRefinements($button, $menu);
                        $productGrid.off(
                            'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd'
                        );
                    }
                );
        });
    } else {
        $menu.addClass(MENU_OPEN);
    }
}

function closeRefinements(e) {
    if (!e.data.menu.hasClass(MENU_OPEN)) {
        return;
    }

    e.data.menu.removeClass(MENU_OPEN);
    removeEventRefinements(e.data.button, e.data.menu);

    if (Foundation.MediaQuery.atLeast('large')) {
        unslickProdTileCarousel(PRODUCTGRID);
        const $productGrid = $(PRODUCTGRID);
        $productGrid
            .removeClass(PRODUCTGRID_OPEN)
            .on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
                $productGrid.off(
                    'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd'
                );
                initProdTileCarousel(PRODUCTGRID);
            });
    }
}

function movePageOnFilterOpen() {
    return new Promise((resolve) => {
        var targetOffset = $(PRODUCTGRID).offset().top - 53;
        var distance = Math.abs($(window).scrollTop() - targetOffset);
        var speed = 1000;
        var duration = Math.min((distance / speed) * 1000, 600);
        $('html, body').animate(
            {
                scrollTop: targetOffset,
            },
            duration,
            resolve
        );
    });
}

/**
 * function to autoclose refinement menu, when touch pagination
 */
function autoCloseRefinements($button, $menu) {
    const refinementMenu = document.querySelector(MENUREFINEMENT);
    const pagination = document.querySelector(PAGINATION);

    if (refinementMenu) {
        const options = {
            threshold: 0.01,
        };

        const callback = ([entries]) => {
            if (entries.isIntersecting) {
                observer.unobserve(pagination);
                closeRefinements({data: {button: $button, menu: $menu}});
            }
        };

        const observer = new IntersectionObserver(callback, options);
        observer.observe(pagination);
    }
}

function addEventRefinements($button, $menu) {
    // CLOSE REFINEMENT
    $button.on('click', {button: $button, menu: $menu}, closeRefinements);

    // EVENT APPEND TO MENU
    // close refinement - view result
    $menu.on('click', '.js-plp-closeRefinements', {button: $button, menu: $menu}, closeRefinements);

    // reset refinement
    $menu.on('click', '.js-plp-resetRefinements', changeRefinements);

    // change event
    $menu.on('click', '.js-changeRefinementValue_button', changeRefinements);
    $menu.on('change', '.js-changeRefinementValue_input', changeRefinements);
}

function removeEventRefinements($button, $menu) {
    $button.removeClass(BUTTON_OPEN).off('click').on('click', openRefinements);

    // Remove all event append to menu .js-plp-refinements
    $menu.off('click change');
}

function changeRefinements() {
    let url = $(this).data('url');
    ajaxCall_changeRefinements(url);
}
